import React, { useContext, useState } from "react";
import UserAccount from "./UserAccount";
import {
  Page,
  Text,
  View,
  Document,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../../../context/MyContext";


const MouDownload = () => {
  const navigate = useNavigate();
  const { MLMStatus, verifyMlmUser } = useContext(MyContext);

  const token = localStorage.getItem("token");
  if (!token) {
    navigate("/login-user");
  }
  const [showUserAccount, setShowUserAccount] = useState(false);
  return (
    <div className={`flex gap-4 pt-20 md:pt-22 ${verifyMlmUser ? "lg:pt-[100px]" : "lg:pt-40"}`}>
      <div
        className={`md:block ${showUserAccount ? "block" : "hidden"
          } absolute md:relative bg-white shadow-md p-4`}
      >
        <UserAccount showUserAccount={showUserAccount} />
      </div>

      <div className="p-6 w-full max-w-full mx-auto bg-white rounded-xl shadow-md flex flex-col items-center pt-4 md:pt-2">
        <h1 className="text-2xl font-bold text-center w-full">
          OurMicroLife MOU Steps
        </h1>
        <div className="space-y-4 w-full text-left items-center">
          <div className="flex items-start space-x-2 w-full ">
            <p className="text-lg font-semibold">Step 1:</p>
            <p className="text-base">Product Listing and Management</p>
          </div>
          <div className="flex items-start space-x-2 w-full">
            <p className="text-lg font-semibold">Step 2:</p>
            <p className="text-base">Secure Payment Gateway Integration</p>
          </div>
          <div className="flex items-start space-x-2 w-full">
            <p className="text-lg font-semibold">Step 3:</p>
            <p className="text-base">Order Processing and Fulfillment</p>
          </div>
          <div className="flex items-start space-x-2 w-full">
            <p className="text-lg font-semibold">Step 4:</p>
            <p className="text-base">Customer Service and Returns</p>
          </div>
          <div className="flex items-start space-x-2 w-full">
            <p className="text-lg font-semibold">Step 5:</p>
            <p className="text-base">Marketing and Promotions</p>
          </div>
        </div>
        <div className="flex justify-center mt-6 w-full">
          {/* <PDFDownloadLink document={MOU} fileName="MOU.pdf">
            {({ loading }) => (
              <button className="px-6 py-3 bg-[#a855f7] text-white rounded-lg hover:bg-[#9333ea] transition duration-300">
                {loading ? "Generating PDF..." : "Download MOU"}
              </button>
            )}
          </PDFDownloadLink> */}


          <button className="px-6 py-3 bg-[#a855f7] text-white rounded-lg hover:bg-[#9333ea] transition duration-300">
            <a href="./OUR MICROLIFE MOU.pdf" download="MOU File.pdf"> Download MOU File</a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MouDownload;
